import { theme } from '../constants';
import { HomeIcon, RefreshIcon } from './Icons';

/**
 * Card shell for the "from" / "to" property columns.
 * `tone` tints the step badge and left edge so the two columns read apart.
 */
function PropertyPanel({
  step,
  title,
  hint,
  tone = theme.accent,
  toneSoft = theme.accentSoft,
  summary,
  loading = false,
  onRefresh = null,
  locked = false,
  lockedNote = null,
  children,
}) {
  return (
    <div
      style={{
        flex: 1,
        minWidth: 260,
        background: theme.surface,
        border: `1px solid ${theme.border}`,
        borderRadius: 12,
        padding: '16px 18px 18px',
        position: 'relative',
        overflow: 'hidden',
        transition: 'opacity 0.2s',
      }}
    >
      <span
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: 3,
          background: locked ? theme.border : tone,
        }}
      />

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <span
            style={{
              width: 24,
              height: 24,
              borderRadius: 7,
              background: locked ? '#f3f4f6' : toneSoft,
              color: locked ? theme.textFaint : tone,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 11.5,
              fontWeight: 800,
            }}
          >
            {step}
          </span>
          <div>
            <div
              style={{
                fontSize: 13.5,
                fontWeight: 700,
                lineHeight: '17px',
                color: locked ? theme.textMuted : theme.text,
              }}
            >
              {title}
            </div>
            <div style={{ fontSize: 11.5, color: theme.textFaint, lineHeight: '16px' }}>
              {locked && lockedNote ? lockedNote : hint}
            </div>
          </div>
        </div>

        {onRefresh && (
          <button
            onClick={onRefresh}
            disabled={loading}
            title="Reload this property"
            style={{
              border: `1px solid ${theme.border}`,
              background: theme.surface,
              borderRadius: 7,
              padding: '5px 7px',
              display: 'flex',
              alignItems: 'center',
              color: theme.textMuted,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.5 : 1,
            }}
          >
            <span className={loading ? 'dmSpin' : undefined} style={{ display: 'flex' }}>
              <RefreshIcon size={13} />
            </span>
          </button>
        )}
      </div>

      {children}

      <div style={{ minHeight: 22, marginTop: 10 }}>
        {loading ? (
          <div className="dmSkeleton" style={{ width: 150, height: 13 }} />
        ) : summary ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: theme.textMuted }}>
            <HomeIcon size={13} />
            <span>
              <strong style={{ color: theme.text, fontWeight: 700 }}>{summary.rooms}</strong> rooms
              <span style={{ color: theme.border, margin: '0 6px' }}>|</span>
              <strong style={{ color: theme.text, fontWeight: 700 }}>{summary.devices}</strong> devices
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default PropertyPanel;
